// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__2T9yJ","title":"Contact_title__l6hOO"};